import { object, ObjectSchema, TypedForm, array } from 'libs/form';
import { localFileScheme } from 'modules/client/common/helpers';
import { LocalFileEntity } from 'modules/client/common/types';

export interface IdentityDocumentFormType {
  identityDocument: {
    files: LocalFileEntity[];
  };
}

export const getIdentityDocumentSchema =
  (): ObjectSchema<IdentityDocumentFormType> =>
    object({
      identityDocument: object({
        files: array().of(localFileScheme.required()).required().min(1),
      }),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<IdentityDocumentFormType>();
